import React from "react";
import { SlUserFemale } from "react-icons/sl";
import { BiPencil, BiSolidPhoneCall, BiCurrentLocation } from "react-icons/bi";
import {
  AiOutlineMail,
  AiOutlineArrowRight,
  AiFillTwitterCircle,
  AiFillLinkedin,
} from "react-icons/ai";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { Flex } from "@chakra-ui/react";
const ContactNew = () => {
  return (
    <footer className="section contact" id="contact">
      <div className="container">
        <div className="contact-card card footer">
          <h2 className="h2 section-title">Drop Me a Line!</h2>

          <div className="wrapper">
            <div class="footer-list">
              <p class="card-subtitle" style={{ fontSize: "24px" }}>
                Contact
              </p>

              <p class="footer-text">
                I want to hear from{" "}
                <b>
                  {" "}
                  <i>YOU</i>
                </b>
                .
              </p>

              <form action="">
                <div className="input-wrapper">
                  <SlUserFemale as="icon" />

                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    required
                    className="input-field"
                    autocomplete="off"
                  />
                </div>

                <div className="input-wrapper">
                  <AiOutlineMail as="icon" />
                  <input
                    type="email"
                    name="email_address"
                    placeholder="Emaill address"
                    required
                    className="input-field"
                    autocomplete="off"
                  />
                </div>
                <div className="input-wrapper">
                  <BiPencil as="icon" />{" "}
                  <input
                    type="text"
                    name="message"
                    placeholder="Message"
                    required
                    className="input-field"
                    autocomplete="off"
                  ></input>
                </div>

                <button type="submit" className="btn btn-primary">
                  <span className="span">Send</span>
                  <AiOutlineArrowRight />{" "}
                </button>
              </form>
            </div>
            <ul className="contact-list">
              <li className="contact-item">
                <div className="contact-icon">
                  <img
                    width="55"
                    height="55"
                    src="https://img.icons8.com/color/96/marker--v1.png"
                    alt="marker--v1"
                  />
                </div>

                <div>
                  <h3 className="contact-item-title">Address</h3>

                  <address className="contact-item-link">
                    Agra, Uttar Pradesh, India
                  </address>
                </div>
              </li>

              <li className="contact-item">
                <div className="contact-icon">
                  <img
                    width="55"
                    height="55"
                    src="https://img.icons8.com/color/96/gmail-new.png"
                    alt="gmail-new"
                  />
                </div>

                <div>
                  <h3 className="contact-item-title">Email</h3>

                  <a
                    href="mailto:guptamansi201@gmail.com"
                    className="contact-item-link"
                  >
                    guptamansi201@gmail.com
                  </a>
                </div>
              </li>

              <li className="contact-item">
                <div className="contact-icon">
                  <img
                    width="55"
                    height="55"
                    src="https://img.icons8.com/fluency/96/phone--v1.png"
                    alt="phone--v1"
                  />
                </div>

                <div>
                  <h3 className="contact-item-title">Phone</h3>

                  <a href="tel:+1234567890" className="contact-item-link">
                    +91 9084360292{" "}
                  </a>
                </div>
              </li>
            </ul>
          </div>
       
        <div class="footer-bottom">
          <p class="copyright">
            Let's Connect{" "}
            <a href="#" class="copyright-link">
              {" "}
              Feel free to contact
            </a>
          </p>

          <ul class="social-list">
            <li>
              <a href="#" class="social-link">
                <AiFillGithub />

                <span class="span">Github</span>
              </a>
            </li>

            <li>
              <a href="#" class="social-link">
                <AiFillLinkedin />

                <span class="span">LinkedIn</span>
              </a>
            </li>
          </ul>
        </div>
      </div>  </div>
    </footer>
  );
};

export default ContactNew;
